module.exports = __webpack_public_path__ + "img/P1013524.46268a58.jpg";